export const mergeTags = (html) => {
  const tags = ['code', 'spoiler', 'b', 'em', 's', 'u'];
  for (const tag of tags) {
    html = html.replace(new RegExp(`</${tag}>(\\n*)<${tag}>`, 'g'), '$1');
  }
  return html;
};
